import { render, staticRenderFns } from "./ListWithIcons.vue?vue&type=template&id=cfc16fc4&scoped=true&"
import script from "./ListWithIcons.vue?vue&type=script&lang=ts&"
export * from "./ListWithIcons.vue?vue&type=script&lang=ts&"
import style0 from "./ListWithIcons.vue?vue&type=style&index=0&id=cfc16fc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc16fc4",
  null
  
)

export default component.exports